import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const StatusContent = ({ data }) => {
    const charts = (data?.document_distribution ?? [])
        .filter(element => Number(element.total) > 0)
        .map((element, index) => ({
            id: `document-expiration-status-${index}`,
            label: element.label,
            total: element.total,
            ranges: (element.ranges ?? []).map(range => ({
                label: range.label,
                qty: Number(range.value)
            }))
        }));

    useEffect(() => {
        charts.forEach(chart => {
            GraphicUtils.horizontalStackedBarChart(chart.ranges, chart.id, "label");
        });

        const labels = [...new Set(
            charts.flatMap(chart => chart.ranges.map(range => range.label))
        )];

        const values = charts.map(chart => [
            chart.label,
            ...labels.map(rangeLabel =>
                chart.ranges.find(range => range.label === rangeLabel)?.qty ?? 0
            )
        ]);

        if (values.length > 0) ReportUtils.createExportableTable(["Documentos", ...labels], values, "Distribuição dos documentos");
    }, [data]);

    return (
        <>
            { charts.map(element => (
                <React.Fragment key={element.id}>
                    <div className="chart-report relative">
                        <span className="chart-title">{element.label}</span>
                        <span className="text-[14px] right-1 leading-[20px] absolute font-bold">Total: {element.total}</span>
                        <div className="mt-1" id={element.id}/>
                    </div>

                    <div className="chart-divisor"/>
                </React.Fragment>
            ))}
        </>
    );
};

export default StatusContent;